import { RESUME_LOGIN_ERROR, RESUME_LOGIN_START, RESUME_LOGIN_SUCCESS, SET_USER_ANONYMOUS } from '../actions/auth';

import { GOOGLE_USER_INFO_SUCCESS } from '../actions/google-auth';

const initialState = {
    firstName: '',
    lastName: '',
    email: '',
    isLoggedIn: false,
    status: {
        error: false,
        fetching: false,
        loaded: false,
        httpStatus: null,
    },
};

export function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case RESUME_LOGIN_START:
            return {
                ...state,
                status: {
                    fetching: true,
                    error: false,
                    loaded: false,
                    httpStatus: null,
                },
            };
        case RESUME_LOGIN_SUCCESS:
            return {
                ...state,
                ...action.payload.data,
                isLoggedIn: true,
                firstName: action.payload.data.firstName,
                lastName: action.payload.data.lastName,
                email: action.payload.data.loginId,
                status: {
                    fetching: false,
                    error: false,
                    loaded: true,
                    httpStatus: action.payload.status,
                },
            };
        case GOOGLE_USER_INFO_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                firstName: action.payload.givenName,
                lastName: action.payload.familyName,
                email: action.payload.email,
                status: {
                    fetching: false,
                    error: false,
                    loaded: true,
                    httpStatus: action.payload.status,
                },
            };
        case RESUME_LOGIN_ERROR:
            return {
                ...state,
                isLoggedIn: false,
                status: {
                    fetching: false,
                    error: true,
                    loaded: false,
                    httpStatus: action.payload.status,
                },
            };
        case SET_USER_ANONYMOUS:
            return {
                ...state,
                isLoggedIn: false,
                firstName: '',
                lastName: '',
                email: '',
            };
        default:
            return state;
    }
}
